import { nameRejext } from "./StringRejex";
import { fa_time } from "./getWeekDays";

export const GetAllCharts = async (apiEndPOint, data) => {
  const req = nameRejext(data.title);

  const res = await apiEndPOint({ name: req, id: data.id });

  if (res.status) {
    const convertedData = {
      data: [],
    };

    let aa = res.data.sort(
      (a, b) => new Date(a.startDate) - new Date(b.startDate)
    );

    res.data.forEach((weekData) => {
      if (weekData.data.length > 0) {
        const resultDates = aa.map((item) => new Date(item.resultDate));

        
        const week = {
          weekStartDay: fa_time(weekData.startDate),
          weekEndDay: fa_time(weekData.endDate),
          data: [],
        };

        let currentResultDate = "";
        let relatedData = [];

        weekData.data.forEach((item) => {
          if (item.resultDate !== currentResultDate) {
            if (currentResultDate !== "") {
              week.data.push({
                resultDate: currentResultDate,
                relatedData: relatedData,
              });
            }
            currentResultDate = item.resultDate;
            relatedData = [];
          }

          relatedData.push(item);
        });

        week.data.push({
          resultDate: currentResultDate,
          relatedData: relatedData,
        });

        convertedData.data.push(week);
      }
    });

    console.log('convertedData' ,convertedData);
    

    return convertedData;
  }
};
